import {WordWithId} from "../../../../common/types/words";
import {Box, Button, FormControl, List, Typography} from "@mui/material";
import React from "react";
import withDrawer, {SideDrawerProps} from "../../../../common/components/SideDrawerView";
import {RequestStatusSnackbarConfig} from "../../../../common/types/requests";
import ListItemReversedTextView from "../../../../common/components/ListItemReversedTextView";
import {VocabularyActionDispatch} from "../../pages/Vocabulary";
import {useWordDeleteView} from "./hooks/useWordDeleteView";
import {useAuth} from "../../../auth/context/AuthContext";

export interface WordDeleteViewProps extends SideDrawerProps {
    word: WordWithId
    actionDispatch?: VocabularyActionDispatch
    snackbar?: RequestStatusSnackbarConfig
}

function WordDeleteView({word, actionDispatch, snackbar, onDrawerClosed} : WordDeleteViewProps) {

    const {currentDeck, deleteFromDeckButtonClicked, deleteFromLanguageButtonClicked} = useWordDeleteView({word, actionDispatch, snackbar});

    const { isAdmin } = useAuth();

    return (
        <FormControl sx={{width: '100%'}}>
            <Typography variant="h5" align="center" fontWeight="bold">Delete word</Typography>
            <Box sx={{mt: 2}}/>
            <List disablePadding>
                <ListItemReversedTextView title={currentDeck!.language} content={word.lemma}/>
                <ListItemReversedTextView title={"Translation"} content={word.translations[0]}/>
            </List>
            <Box width={'100%'} mt={2} justifyContent={'center'} alignItems={'center'} display={'flex'}>
                <Typography variant="body1">This word will be gone forever!</Typography>
            </Box>
            {!isAdmin && (
                <Box display="flex" width="100%" gap={3} mt={3}>
                    <Button color="error" sx={{borderRadius: 2, flex: 1}} variant={"contained"} onClick={deleteFromDeckButtonClicked}>Delete</Button>
                    <Button color="primary" sx={{borderRadius: 2, flex: 1}} variant={"contained"} onClick={() => onDrawerClosed(true)}>Cancel</Button>
                </Box>
            )}
            {isAdmin && (
                <Box width="100%" gap={3} mt={3} px={2}>
                    <Button color="error" sx={{borderRadius: 2, flex: 1, width: "100%"}} variant={"contained"} onClick={deleteFromDeckButtonClicked}>Delete for me</Button>
                    <Button color="error" sx={{borderRadius: 2, flex: 1, width: "100%", mt: 2}} variant={"contained"} onClick={deleteFromLanguageButtonClicked}>Delete for everyone</Button>
                    <Button color="primary" sx={{borderRadius: 2, flex: 1, width: "100%", my: 2}} variant={"contained"} onClick={() => onDrawerClosed(true)}>Cancel</Button>
                </Box>
            )}
        </FormControl>
    )

}

export default withDrawer<WordDeleteViewProps>(WordDeleteView);